<div id="popup">
  <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
      <span style="color: white; padding-left: 15px;">
          Update Sub-Status: {{data.nodeName}}
      </span>
      <button mat-icon-button (click)="onCancel()" style="color: white;">
          <mat-icon>
              close
          </mat-icon>
      </button>
  </div>
  <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style="margin: 0px; padding: 0px;">
      <div class="padding-11" style="padding: 15px;">
          <div fxLayout="column">
            
            <div style="margin-bottom: 20px;">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Notes</mat-label>
                <textarea matInput [(ngModel)]="notes" rows="4" placeholder="Enter notes..." [required]="data.requireNotes"></textarea>
                <mat-error *ngIf="data.requireNotes && (!notes || notes.trim() === '')">Notes are required for this status.</mat-error>
              </mat-form-field>
            </div>
          
            <div style="margin-bottom: 20px;">
              <calsoft-common-file-upload (fileUploadResult)="getImage($event)" [type]="'stageHistory'"></calsoft-common-file-upload>
          
              <div *ngIf="data.requireImages && images.length === 0" style="color: #f44336; font-size: 12px; margin-top: 5px;">
                At least one image is required for this status.
              </div>
              
              <div style="display: flex; gap: 10px; margin-top: 10px; flex-wrap: wrap;">
                <div *ngFor="let img of images; let i = index" style="position: relative;">
                  <calsoft-common-images [src]="serverPath + img" [height]="'80px'" [width]="'auto'" [alt]=""></calsoft-common-images>
                  <button mat-icon-button (click)="removeImage(i)" 
                          style="position: absolute; top: -10px; right: -10px; background: white; color: red; width: 24px; height: 24px; line-height: 24px;">
                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;">close</mat-icon>
                  </button>
                </div>
              </div>
            </div>

          </div>
          
          <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">
              <button mat-raised-button (click)="onCancel()" tabindex="-1">Cancel</button>
              <button [disabled]="!isValid || text === 'Processing...'" (click)="onSave()" mat-raised-button color="primary">
                  {{text}}
                  <mat-icon *ngIf="text === 'Processing...'" style="margin-left: 5px;">
                      <mat-spinner color="accent" diameter="20"></mat-spinner>
                  </mat-icon>
              </button>
          </div>
      </div>
  </mat-dialog-content>
</div>
